import { MEDIA_API_PATH } from "../config/apiPaths";
import { getRequest } from "./config/GetRequest";
import { postRequest } from "./config/PostRequest";

export const listRequest = (data) => async () => {
  try {
    let result = await getRequest(MEDIA_API_PATH.LIST_PATH, null, false);
    return result;
  } catch (error) {
    // TODO Handle Error
  }
};

export const createUpdateRequest = (data) => async () => {
  try {
    let result = await postRequest(
      MEDIA_API_PATH.CREATE_UPDATE_PATH,
      data,
      false
    );
    return result;
  } catch (error) {
    // TODO Handle Error
    return error;
  }
};

export const deleteMediaRequest = (data) => async () => {
  try {
    let result = await deleteMediaRequest(
      `${MEDIA_API_PATH.DELETE_PATH}?id=${data.id}`,
      null,
      false
    );
    return result;
  } catch (error) {
    // TODO Handle Error
    return error;
  }
};
